import { render, staticRenderFns } from "./MessageInput.vue?vue&type=template&id=40b2ea76&scoped=true&"
import script from "./message-input.js?vue&type=script&lang=js&"
export * from "./message-input.js?vue&type=script&lang=js&"
import style0 from "./message-input.scss?vue&type=style&index=0&id=40b2ea76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b2ea76",
  null
  
)

export default component.exports